/**
 * Frontend mirror of backend CITY_TRANSLATIONS (cities_controller.js).
 * Keep in sync when cities are added/renamed on the backend.
 *
 * Used to translate BG canonical city names for display in places that
 * don't have (or can't wait on) the /api/cities/cities response — e.g.
 * hardcoded defaults, or a "City - District" string stored in
 * selectedLocation before the cities list has loaded.
 */
const CITY_TRANSLATIONS = {
  'София':          { en: 'Sofia',          ru: 'София' },
  'Пловдив':        { en: 'Plovdiv',        ru: 'Пловдив' },
  'Варна':          { en: 'Varna',          ru: 'Варна' },
  'Бургас':         { en: 'Burgas',         ru: 'Бургас' },
  'Русе':           { en: 'Ruse',           ru: 'Русе' },
  'Стара Загора':   { en: 'Stara Zagora',   ru: 'Стара Загора' },
  'Плевен':         { en: 'Pleven',         ru: 'Плевен' },
  'Велико Търново': { en: 'Veliko Tarnovo', ru: 'Велико Тырново' },
  'Сливен':         { en: 'Sliven',         ru: 'Сливен' },
  'Враца':          { en: 'Vratsa',         ru: 'Враца' },
  'Габрово':        { en: 'Gabrovo',        ru: 'Габрово' },
  'Кюстендил':      { en: 'Kyustendil',     ru: 'Кюстендил' },
  'Монтана':        { en: 'Montana',        ru: 'Монтана' },
  'Перник':         { en: 'Pernik',         ru: 'Перник' },
  'Силистра':       { en: 'Silistra',       ru: 'Силистра' },
  'Смолян':         { en: 'Smolyan',        ru: 'Смолян' },
  'Търговище':      { en: 'Targovishte',    ru: 'Търговище' },
  'Видин':          { en: 'Vidin',          ru: 'Видин' },
  'Разград':        { en: 'Razgrad',        ru: 'Разград' },
  'Хасково':        { en: 'Haskovo',        ru: 'Хасково' },
  'Шумен':          { en: 'Shumen',         ru: 'Шумен' },
  'Добрич':         { en: 'Dobrich',        ru: 'Добрич' },
  'Ямбол':          { en: 'Yambol',         ru: 'Ямбол' },
  'Благоевград':    { en: 'Blagoevgrad',    ru: 'Благоевград' },
  'Пазарджик':      { en: 'Pazardzhik',     ru: 'Пазарджик' },
  'Кърджали':       { en: 'Kardzhali',      ru: 'Кырджали' },
  'Казанлък':       { en: 'Kazanlak',       ru: 'Казанлык' },
  'Димитровград':   { en: 'Dimitrovgrad',   ru: 'Димитровград' },
  'Асеновград':     { en: 'Asenovgrad',     ru: 'Асеновград' },
};

/**
 * Translate a BG canonical city name to the given language.
 * Falls back to the original name if no translation exists
 * (lang === 'bg' or unrecognized city).
 */
export function translateCityName(name, lang) {
  if (!name) return name;
  const entry = CITY_TRANSLATIONS[name];
  if (!entry) return name;
  if (lang === 'en' && entry.en) return entry.en;
  if (lang === 'ru' && entry.ru) return entry.ru;
  return name;
}

/**
 * Translate a location string that may be a plain city name or a
 * "City - District" composite (as produced by LocationDropdown's
 * handleSelectDistrict). The district portion is a proper noun and is
 * left untranslated; only the city portion is translated.
 */
export function translateLocationString(str, lang) {
  if (!str || typeof str !== 'string') return str;
  const separator = ' - ';
  const idx = str.indexOf(separator);
  if (idx === -1) return translateCityName(str, lang);
  const city = str.slice(0, idx);
  const district = str.slice(idx + separator.length);
  return `${translateCityName(city, lang)}${separator}${district}`;
}

export default CITY_TRANSLATIONS;
